import { SET_UPLOADING_STATE } from "../../types";

const initialState = {
    uploadingState: {
        isUploading: false,
        uploadingFilename: "",
        uploadingProgress: 0
    }
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_UPLOADING_STATE: {
            return {
                ...state,
                uploadingState: {
                    ...state.uploadingState,
                    ...payload
                }
            };
        }
        default:
            return state;
    }
}